exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// D:/Repositorios/FacturacionWeb/src/app/core/components/navigation/horizontal/nav-collapse/nav-horizontal-collapse.component.scss
// module id = ../../../../../src/app/core/components/navigation/horizontal/nav-collapse/nav-horizontal-collapse.component.scss
// module chunks = main